/**
 * @file User / material analysis UI — pages/Dashboard/User/MaterialAnalysisInput/materialAnalysisConstants.ts.
 */

export const AGNOSTIC_SUB_MATERIAL_VALUE = "agnostic";
/** Exported const — AGNOSTIC SUB MATERIAL LABEL. */
export const AGNOSTIC_SUB_MATERIAL_LABEL = "Agnostic";

/** Exported function — is Agnostic Sub Material Selection. */
export function isAgnosticSubMaterialSelection(value: string): boolean {
  return value === AGNOSTIC_SUB_MATERIAL_VALUE;
}

/** Exported function — is Agnostic Sub Material Name. */
export function isAgnosticSubMaterialName(name: string): boolean {
  const norm = name.trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  return norm === "agnostic";
}
